export default __webpack_public_path__ + "static/chainalysis-logo-524956a68f8eb1773f215bf2aa9d0ad2.png";